import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
// import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import Swal from 'sweetalert2'; 
import { EmailServiceModel } from '../models/email-service.model';
import { EmailLog } from '../models/email-log.modal';
import { SharedService } from './shared.service';
declare var $: any;

@Injectable({
    providedIn: 'root'
})

 
export class EmailService {
    page_name: string = '';
    private baseUrl: string = 'email';
    email_service: EmailServiceModel = new EmailServiceModel('','','','','');
    email_attachment: { fileName: string; contentType: string; data: string } = { fileName: '', contentType: '', data: '' };
    email_log: EmailLog = new EmailLog(0,0,0,0,'','','','','','',false,'','','');
    email_logs: EmailLog[] = [];

    constructor(
        private http: HttpClient, 
        private api: ApiService, 
    ) { }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }

    private EmailLogSubject = new Subject<void>(); 
    EmailLogObservable = this.EmailLogSubject.asObservable(); 
    triggerEmailLog() { 
      this.EmailLogSubject.next();
    }
 
    openEmailModal(params: { from?: string; to?: string | string[]; subject?: string; body?: string, attachmentPath: { fileName: string; contentType: string; data: string } }): void {
        const to = Array.isArray(params?.to) ? params.to.join(', ') : (params?.to || '');
        this.email_service.From = params?.from || '';
        this.email_service.To = to;
        this.email_service.Subject = params?.subject || '';
        this.email_service.Body = params?.body || '';
        this.email_attachment = params?.attachmentPath || { fileName: '', contentType: '', data: '' };

        ($('#modalEmail') as any).modal('show');
    }

    sendEmailFromState(){
        const sendFrom = this.email_service.From || '';
        const sendTo = (this.email_service.To || '').split(',').map(x => x.trim()).filter(x => !!x);
        const subject = this.email_service.Subject || '';
        const body = this.email_service.Body || '';
        return this.sendEmail(sendFrom, sendTo, subject, body);
    }

  // Send a report as an email attachment
  sendEmailWithReport(sendFrom: string, sendTo: string[], subject: string, body: string, attachemnt : { fileName: string; contentType: string; data: string }){
    const payload = {
      sendFrom: sendFrom,
      sendTo: sendTo,
      subject: subject,
      body: body,
      attachments: [
        { fileName: attachemnt.fileName, contentType: attachemnt.contentType, dataBase64: attachemnt.data }
      ]
    };
    let promise = new Promise((resolve, reject) => {
        this.api.post(`${this.baseUrl}/send`, payload)
        .subscribe({
            next: (res: any) => {  

                resolve(res);
            },
            error: (error) => {
                reject(error);
            }
        });
    });
    return promise;
  }

  sendEmail(sendFrom: string, sendTo: string[], subject: string, body: string){
        let promise = new Promise((resolve, reject) => {
            const payload = {
            sendFrom: sendFrom,
            sendTo: sendTo,
            subject: subject,
            body: body,
        }

            this.api.post(`${this.baseUrl}/send`, payload)
            .subscribe({
                next: (res: any) => {  
                    resolve(res);
                },
            });
        });
        
        return promise;
    }

    sendEmailWithHtml(sendFrom: string, sendTo: string[], subject: string, body: string){
        let promise = new Promise((resolve, reject) => {
            const payload = {
                sendFrom: sendFrom,
                sendTo: sendTo,
                subject: subject,
                body: body, 
            };
            this.api.post(`${this.baseUrl}/SendHtml`, payload)
                .subscribe({
                    next: (res: any) => {  
                        resolve(res);
                    },
                    error: (error) => {
                        reject(error);
                    }
                });
        });
        return promise;
    }

    Email(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string, pet_no?: number, client_no?: number, clinic_no?: number, username?: string) {
        Swal.fire({
          title: 'Sending email...',
          text: 'Please wait...',
          icon: 'info',
          allowOutsideClick: false,
          showConfirmButton: false,
        });
    
        
        this.sendEmail(
          emailFrom, 
          emailTo.split(',').map(x => x.trim()).filter(x => !!x),
          emailSubject, 
          emailBody).then((res: any) => {
            Swal.close();
            const d = (res && res.data) || {} as any;
            const succeeded = Number(d.succeeded) || 0;
            const failed = Number(d.failed) || 0;
            const failures = Array.isArray(d.failures) ? d.failures : [];
            const emailId = d.email_id || '';
            const reqId = (res && res.request_id) || '';
            const ok = succeeded > 0 && failed === 0;
    
            const details: string[] = [
              `<div><strong>Request ID:</strong> ${reqId || '-'}</div>`,
              `<div><strong>Email ID:</strong> ${emailId || '-'}</div>`,
              `<div><strong>Results:</strong> ${succeeded} succeeded, ${failed} failed</div>`
            ];
            if (failed > 0 && failures.length) {
              const items = failures
                .slice(0, 5)
                .map((f: any) => `<li>${f?.reason || f?.message || JSON.stringify(f)}</li>`) 
                .join('');
              details.push(`<div class="mt-2"><strong>Failures:</strong><ul style="margin:4px 0 0 20px;">${items}</ul></div>`);
            }
    
            let emailLog = new EmailLog(0,pet_no,client_no,clinic_no,username,emailTo,emailFrom,emailSubject,emailBody,new Date(),ok,reqId,emailId,failures.join(','));
            this.setupEmailLog(1, emailLog).then((res: any) => {
              this.triggerEmailLog();
            });

            Swal.fire({
              icon: ok ? 'success' : (failed > 0 ? 'error' : 'info'),
              title: ok ? 'Email sent' : (failed > 0 ? 'Email failed' : 'Email status'),
              //html: details.join('')
            });
          }).catch((err: any) => {
            Swal.fire({
              icon: 'error',
              title: 'Failed to send',
              text: (err && (err.message || err.error || err.statusText)) || 'An error occurred.'
            }); 
          })
    }

    EmailWithReport(emailFrom: string, emailTo: string, emailSubject: string, emailBody: string, emailAttachments: { fileName: string; contentType: string; data: string }) {
        Swal.fire({
        title: 'Sending email...',
        text: 'Please wait...',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        });

        this.sendEmailWithReport(
        emailFrom, 
        emailTo.split(',').map(x => x.trim()).filter(x => !!x),
        emailSubject, 
        emailBody, 
        emailAttachments)
        .then((res: any) => {
        Swal.close();
        const data = res?.data ?? res;
        const failed = data?.failed ?? 0;
        const succeeded = data?.succeeded ?? 0;
        const failures = Array.isArray(data?.failures) ? data.failures : [];

        if (failed > 0) {
            Swal.fire({
            icon: 'error',
            title: 'Email failed',
            html: `Succeeded: ${succeeded}<br/>Failed: ${failed}<br/>${failures.join('<br/>')}`,
            });
        } else {
            Swal.fire({
            icon: 'success',
            title: 'Email sent',
            text: `Succeeded: ${succeeded}`,
            });
        }
        })
        .catch((err: any) => {
        const message = typeof err === 'string' ? err : (err?.error?.message || err?.message || JSON.stringify(err));
        Swal.fire({ icon: 'error', title: 'Error', text: message });
        });
    } 

    //List<EmailLogModel> GetEmailLog(int pet_no,int client_no,int clinic_no)
    GetEmailLog(pet_no: number, client_no: number, clinic_no: number){
        let promise = new Promise((resolve, reject) => {
            this.api.get(`${this.baseUrl}/GetEmailLog?pet_no=${pet_no}&client_no=${client_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                  if (res && res.results > 0) { 
                    this.email_logs = res.data.map((element: any) => {
                        return new EmailLog(element.ID, element.pet_no, element.client_no, element.clinic_no, element.username, element.EmailTo, element.EmailFrom, element.EmailSubject, element.EmailBody, element.EmailDate, element.ApiStatus, element.ApiRequestId, element.ApiEmailId, element.ApiRemarks);
                    });
                    resolve(this.email_logs);
                  } else {
                    this.email_logs = [];
                    resolve(this.email_logs);
                  } 
                });
        });
        return promise;
    }
    
    setupEmailLog(ActionType: number, emailLog: EmailLog){
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupEmailLog?ActionType=${ActionType}`, emailLog)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        resolve(res.data);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }


}
